<div class="p-6 text-center dark:text-white-dark ltr:sm:text-left rtl:sm:text-right">
    
</div>
